import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { DEFAULT_PAGE_SIZE } from '@css-xp/ppc-constants';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchOrdersForTransactionAccountInPPC } from './queries/fetch-orders-for-transaction-account';

interface UseFetchOrdersForTransactionAccountPPCQueryVariables {
  transactionAccountId: string;
  filterOptions: generatedTypesNew.FilterOption[];
}

export const useFetchOrdersForTransactionAccountPPCQuery = ({
  transactionAccountId,
  filterOptions,
}: UseFetchOrdersForTransactionAccountPPCQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchOrdersByTransactionAccountIdInPpcQuery,
    generatedTypesNew.FetchOrdersByTransactionAccountIdInPpcQueryVariables
  >(fetchOrdersForTransactionAccountInPPC, {
    variables: {
      transactionAccountId,
      searchOptions: { first: DEFAULT_PAGE_SIZE, offset: 0 },
      filterOptions: filterOptions,
      fetchIsExternallyBilled: true,
    },
    displayName: 'fetchOrdersForTransactionAccountInPPC',
    skip: !transactionAccountId,
    client: ansClient,
  });
};
